/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper'
import { Typography, Divider, Grid } from '@material-ui/core';

import RegisterIC from './RegisterIC'
import AddWorldView from './AddWorldView'
import ConfigureOps from './ConfigureOps'
import DataDevices from './DataDevices'
import FinishSetup from './FinishSetup'


const styles = theme => ({})

const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        // primary: {
        //     main: "#FF6600",  
        //     contrastText: "#FFFFFFFF"
        // },
        secondary: {
          main: '#ff9100',
        },
      },
})

function getSteps() {
    return ['Create Information Channel', 'Add World View', 'Configure Operations', 'Add Information Units', 'Finish Setup'];
}
class CreateIC extends Component {
    state = {
        activeStep : 0,
        steps : getSteps(),
        ic_name : null,
        ic : {},
        tab_panel_height : 0
    }

    tabPanel = React.createRef()

    componentDidMount () {
        const tabPanelHeight = this.tabPanel.current.clientHeight
        console.log('Tab Panel Height : ', tabPanelHeight)
        this.setState({...this.state, tab_panel_height : tabPanelHeight})
    }

    handleStep = (step) => {
        this.setState({...this.state, activeStep : step})
    }

    handleNext = (obj) => {
        this.setState({...this.state, 
            activeStep : this.state.activeStep === this.state.steps.length - 1 ? this.state.activeStep :this.state.activeStep + 1,
            ...obj
        }, () => {
            console.log('Create IC State: ', this.state)
        })
    };
    
    handleBack = () => {
        this.setState({...this.state, activeStep : this.state.activeStep === 0 ? this.state.activeStep : this.state.activeStep - 1})
    };
    
    renderStep = () => {
        if (this.state.activeStep === 0) {
            return (
                <Grid item xs = {4}>
                    <RegisterIC nextStep = {this.handleNext} prevStep = {this.handleBack}/>
                </Grid>
            )
        } else if (this.state.activeStep === 1) {
            return (
                <Grid item xs = {12} >
                    <AddWorldView nextStep = {this.handleNext} prevStep = {this.handleBack} ic_name = {this.state.ic_name} maxHeight = {this.state.tab_panel_height}/>
                </Grid>
            )
        } else if (this.state.activeStep === 2) {
            return (
                <Grid item xs = {12}>
                    <ConfigureOps nextStep = {this.handleNext} prevStep = {this.handleBack} ic_name = {this.state.ic_name} maxHeight = {this.state.tab_panel_height}/>
                </Grid>
            )
        } else if (this.state.activeStep === 3) {
            return (
                <Grid item xs = {12}>
                    <DataDevices nextStep = {this.handleNext} prevStep = {this.handleBack} ic_name = {this.state.ic_name}/>
                </Grid>
            )
        } else if (this.state.activeStep === 4) {
            return (
                <Grid item xs = {12}>
                    <FinishSetup nextStep = {this.handleNext} prevStep = {this.handleBack} ic_name = {this.state.ic_name}/>
                </Grid>
            )
        } 
    }

    render() {
        return (
            <Paper style = {{width : '100%', height : 'calc(100vh - 70px)'}} >
                <div style = {{width : '100%', height : '100%',display : 'flex', flexDirection : 'column'}}>
                    <div>
                        <Typography style = {{padding: '10px'}} variant = 'h6'>Information Channel Setup <em>  {this.state.ic_name}  </em></Typography>
                        <Divider/>
                        <ThemeProvider theme = {blue_theme}>
                            <Stepper style = {{width : '100%'}} activeStep={this.state.activeStep} alternativeLabel>
                                {this.state.steps.map((label, i) => (
                                    <Step key={label}>
                                        <StepLabel 
                                            // onClick = {() => this.handleStep(i)}
                                        >{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </ThemeProvider>
                        <Divider/>
                    </div>
                    <div ref = {this.tabPanel} style ={{width: '100%', flexGrow : 1}}>
                        <Grid style = {{width : '100%', height : '100%', backgroundColor : '#F0F0F0', overflow: 'auto'}} xs = {12} container justify = 'center' alignItems = 'center'>
                            {this.renderStep()}
                        </Grid>
                    </div>
                </div>
                {/* <ThemeProvider theme = {blue_theme}>
                    <Divider/>
                    <div style = {{padding : '10px'}}>
                        <Button style = {{margin: '5px'}} onClick = {this.handleBack}>
                            Back
                        </Button>
                        <Button variant="contained" color="primary" onClick = {this.handleNext}>
                            Next
                        </Button>
                    </div>
                </ThemeProvider> */}
            </Paper>
        );
    }
}

export default withStyles(styles)(CreateIC);